export const INIT = 'hall/sw/INIT'
export const UPDATE = 'hall/sw/UPDATE'
export const RELOAD = 'hall/sw/RELOAD'
